import React, { Fragment } from 'react'
import { Table } from 'antd'
import RefreshButton from '../../../elements/Buttons/RefreshButton'
import { StyledStrong } from '../../../components/Common/Amount'

function List(props) {
  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      render: (value, record) => <a onClick={() => props.onShow(record, 'edit')}>{value}</a>,
    },
    {
      title: 'Category',
      dataIndex: 'category',
    },
  ]
  const { list, fetch, fetching } = props
  return (
    <Table
      title={() => (
        <Fragment>
          <StyledStrong>Centers</StyledStrong>
          <RefreshButton onClick={fetch} />
        </Fragment>
      )}
      showHeader={false}
      loading={fetching}
      columns={columns}
      dataSource={list}
      rowKey={'_id'}
    />
  )
}

List.propTypes = {}
List.defaultProps = {}

export default List
